import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { TableLazyLoadEvent, Table } from 'primeng/table';
import { ProductControllerGetAll$Params } from 'src/app/api/fn/product/product-controller-get-all';
import { AgreementProductItem, ProductItem } from 'src/app/api/models';
import { ProductService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-prod-picker',
  templateUrl: './modal-prod-picker.component.html',
  styleUrls: ['./modal-prod-picker.component.scss'],
})
export class ModalProdPickerComponent {
  @ViewChild('dt1') table?: Table;
  @ViewChild('keywordFilter') keywordFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('brandFilter') brandFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('codeSupplierFilter') codeSupplierFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('codeInternalFilter') codeInternalFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('codeEanFilter') codeEanFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('partNumberFilter') partNumberFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('descShortFilter') descShortFilter?: ElementRef<HTMLInputElement>;
  selectedCat = new FormControl<any>(undefined);

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];

  question_title: string;
  chosenProducts?: ProductItem[] = [];

  products: ProductItem[] = [];
  productsId?: number;
  loading: boolean = false;
  totalRecords: number = 0;
  selectedProduct: ProductItem[] = [];
  queryRole?: any;
  agreement_id?: number;
  restrict_to_agreement_id?: number;
  showAllProductsControl = new FormControl<boolean>(false, { nonNullable: true });
  pickerType?: string;
  selectedProductControl = new FormControl(null);
  showOnlySerializedProducts?: boolean;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private prodService: ProductService
  ) {
    this.question_title = config.data!.question_title;
    this.chosenProducts = config.data!.chosenProducts;
    this.agreement_id = config.data!.agreement_id;
    this.restrict_to_agreement_id = config.data!.restrict_to_agreement_id;

    this.selectedProduct = [...(this.chosenProducts ?? [])];
    this.pickerType = config.data.pickerType;
    this.showOnlySerializedProducts = config.data.showOnlySerializedProducts;
  }

  onShowAllProductsChange() {
    this.table?.reset();
  }

  loadProducts(event: TableLazyLoadEvent) {
    this.loading = true;
    const params: ProductControllerGetAll$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      exclude_products_from_agreement_id: this.agreement_id,
    };
    if (this.restrict_to_agreement_id && !this.showAllProductsControl.value) {
      params.include_products_from_agreement_id = this.restrict_to_agreement_id;
    }
    if (event.sortField) {
      params.field = event.sortField as ProductControllerGetAll$Params['field'];
      params.direction = event.sortOrder === -1 ? 'desc' : 'asc';
    }
    if (this.showOnlySerializedProducts) {
      params.serialized = true;
    }

    if (event.globalFilter != null) {
      // keyword
      if (event.globalFilter[0] != '') {
        params.query = event.globalFilter[0];
      }
      // brand
      if (event.globalFilter[1] != '') {
        params.brand = event.globalFilter[1];
      }
      // code_supplier
      if (event.globalFilter[2] != '') {
        params.code_supplier = event.globalFilter[2];
      }
      // code_ean
      if (event.globalFilter[3] != '') {
        params.code_ean = event.globalFilter[3];
      }
      // part_number
      if (event.globalFilter[4] != '') {
        params.part_number = event.globalFilter[4];
      }
      // category
      if (this.selectedCat.value != undefined && this.selectedCat.value.key) {
        params.cat_id = this.selectedCat.value.key;
      }
      // desc_short
      if (event.globalFilter[6] != '') {
        params.desc_short = event.globalFilter[6];
      }
      // code_internal
      if (event.globalFilter[7] != '') {
        params.code_internal = event.globalFilter[7];
      }
    }
    this.prodService.productControllerGetAll(params).subscribe({
      next: ({ data }) => {
        this.products = data.list;
        this.totalRecords = data.count;
        this.loading = false;
        this.selectedProduct = [...this.selectedProduct];
      },
    });
    // if (this.chosenProducts) {
    //   this.selectedProduct = this.chosenProducts;
    // }
  }

  clear(table: Table) {
    table.clear();
    if (this.keywordFilter) {
      this.keywordFilter.nativeElement.value = '';
    }
    if (this.brandFilter) {
      this.brandFilter.nativeElement.value = '';
    }
    if (this.codeSupplierFilter) {
      this.codeSupplierFilter.nativeElement.value = '';
    }
    if (this.codeEanFilter) {
      this.codeEanFilter.nativeElement.value = '';
    }
    if (this.partNumberFilter) {
      this.partNumberFilter.nativeElement.value = '';
    }
    if (this.descShortFilter) {
      this.descShortFilter.nativeElement.value = '';
    }
    if (this.selectedCat.value) {
      this.selectedCat.setValue(undefined);
    }
    if (this.codeInternalFilter) {
      this.codeInternalFilter.nativeElement.value = '';
    }
  }

  close() {
    this.ref.close();
  }

  save() {
    this.pickerType === 'radio'
      ? this.ref.close({ value: this.selectedProductControl.value })
      : this.ref.close({ value: this.selectedProduct });
  }

  checkIfProdIsChosen(p: ProductItem) {
    if (this.chosenProducts) {
      return this.chosenProducts?.some(cp => cp.id === p.id);
    }
    return false;
  }
}
